export interface Achievement {
  id: string;
  title: string;
  description: string;
  icon: string;
  unlocked: boolean;
  progress?: number;
  requirement: string;
}

export const ACHIEVEMENTS: Achievement[] = [
  {
    id: "early_adopter",
    title: "Early Adopter",
    description: "Joined Green Guard's first wave of users",
    icon: "🌟",
    unlocked: true,
    requirement: "Join during the beta phase"
  },
  {
    id: "savings_master",
    title: "Savings Master",
    description: "Save 20% of income for 3 consecutive months",
    icon: "💰",
    unlocked: false,
    progress: 65,
    requirement: "Save 20% monthly for 3 months"
  },
  {
    id: "ai_explorer",
    title: "AI Explorer",
    description: "Use all AI-powered features",
    icon: "🤖",
    unlocked: false,
    progress: 40,
    requirement: "Try all AI features"
  },
  {
    id: "budget_guru",
    title: "Budget Guru",
    description: "Stay within budget for 6 months",
    icon: "📊",
    unlocked: false,
    progress: 83,
    requirement: "Maintain budget for 6 months"
  },
  {
    id: "investment_pro",
    title: "Investment Pro",
    description: "Create and maintain a diverse investment portfolio",
    icon: "📈",
    unlocked: false,
    progress: 30,
    requirement: "Invest in 5 different assets"
  },
  {
    id: "green_saver",
    title: "Green Saver",
    description: "Reduce carbon footprint through smart spending",
    icon: "🌱",
    unlocked: false,
    progress: 45,
    requirement: "Make eco-friendly purchases"
  }
];

export interface BankAccount {
  accountType: 'checking' | 'savings' | 'investment';
  accountNumber: string;
  bankName: string;
  routingNumber: string;
  isVerified: boolean;
}

export interface FinancialInfo {
  monthlyIncome: number;
  accounts: BankAccount[];
  currency: string;
  paymentSchedule: 'weekly' | 'biweekly' | 'monthly';
}

export interface LocationSettings {
  isEnabled: boolean;
  currentLocation?: {
    city: string;
    country: string;
    coordinates?: {
      latitude: number;
      longitude: number;
    }
  };
  shareLocation: boolean;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  avatar: string;
  role: string;
  bio: string;
  location: string;
  phone: string;
  dateJoined: string;
  socialLinks: {
    linkedin?: string;
    twitter?: string;
    github?: string;
  };
  preferences: {
    emailNotifications: boolean;
    pushNotifications: boolean;
    monthlyReports: boolean;
    twoFactorAuth: boolean;
  };
  financialProfile: {
    income: number;
    savingsGoal: number;
    riskTolerance: 'low' | 'medium' | 'high';
    investmentPreference: string[];
  };
  financialInfo: FinancialInfo;
  locationSettings: LocationSettings;
}

export const DEFAULT_USER_PROFILE: UserProfile = {
  id: "1",
  name: "Michael Coffie",
  email: "michael@example.com",
  avatar: "/michael-coffie.jpg",
  role: "AI Finance Pioneer 🚀",
  bio: "Passionate about combining AI with financial technology to help people make better decisions.",
  location: "New York, USA",
  phone: "+1 (555) 123-4567",
  dateJoined: "2024-01-01",
  socialLinks: {
    linkedin: "https://linkedin.com/in/michaelcoffie",
    twitter: "https://twitter.com/michaelcoffie",
    github: "https://github.com/michaelcoffie"
  },
  preferences: {
    emailNotifications: true,
    pushNotifications: true,
    monthlyReports: true,
    twoFactorAuth: false
  },
  financialProfile: {
    income: 75000,
    savingsGoal: 25000,
    riskTolerance: 'medium',
    investmentPreference: ['stocks', 'crypto', 'real estate']
  },
  financialInfo: {
    monthlyIncome: 0,
    accounts: [],
    currency: 'USD',
    paymentSchedule: 'monthly'
  },
  locationSettings: {
    isEnabled: false,
    shareLocation: false
  }
}; 